import React from "react";

import classNames from "classnames";
import { Grid, Table } from "icons";
import Pluralize from "pluralize";

import {
  Typography,
  SearchBar,
  Button,
  Tooltip,
} from "clearsense-ui/components";
import Filter from "components/Common/FilterHeader/Filter";
import {
  FILTER_CONDITIONS,
  FILTER_OPERATIONS,
} from "components/DataManagement/constants/stewardFilter";

const ActionHeader = ({
  filterConditions,
  setFilterConditions,
  totalCount,
  isTableView,
  setIsTableView,
}) => {
  const handleSwitchView = view => {
    if (view === isTableView) {
      return;
    }
    setIsTableView(view);
  };

  return (
    <div className="flex justify-between my-4 space-x-4">
      <div className="flex w-4/6 justify-between">
        <div className="flex items-center space-x-4">
          <Typography style="large" type="bold">
            {Pluralize("Dataset", totalCount, true)}
          </Typography>
          <Filter
            title="Datasets"
            filterConditions={filterConditions}
            setFilterConditions={setFilterConditions}
            conditionOptions={FILTER_CONDITIONS}
            filterOperations={FILTER_OPERATIONS}
          />
        </div>
        <div className="flex items-center space-x-2">
          <Tooltip
            content={
              isTableView ? "Table view is enabled" : "Switch to table view"
            }
            position="bottom"
          >
            <Button
              icon={Table}
              style="secondary"
              className={classNames({
                "bg-gray-300 dark:bg-gray-400": isTableView,
              })}
              onClick={() => handleSwitchView(true)}
            />
          </Tooltip>
          <Tooltip
            content={
              !isTableView ? "Card view is enabled" : "Switch to card view"
            }
            position="bottom"
          >
            <Button
              icon={Grid}
              style="secondary"
              className={classNames({
                "bg-gray-300 dark:bg-gray-400": !isTableView,
              })}
              onClick={() => handleSwitchView(false)}
            />
          </Tooltip>
        </div>
      </div>
      <div className="flex items-center w-2/6 space-x-4">
        <SearchBar placeholder="Search Data Sets" />
      </div>
    </div>
  );
};

export default ActionHeader;
